module.exports = __webpack_public_path__ + "static/media/logo-text.2afe3b69.png";